import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import TopNavMenu from 'components/TopNavMenu';
import { MENUS } from 'constants/menus';
import { Link } from 'react-router-dom';

const MainMenu = () => {
  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'space-between', flex: 1, paddingLeft: '5%', paddingRight: '12px' }}
    >
      <TopNavMenu
        menus={MENUS}
        isParentMenu={true}
        borderBottom={`4px solid #fff`}
        style={{
          color: 'white',
          fontWeight: 600,
        }}
      />
      <Link to="/search">
        <Tooltip title="Search shipments" arrow placement="bottom">
          <IconButton style={{ color: '#fff' }}>
            {' '}
            <SearchIcon />{' '}
          </IconButton>
        </Tooltip>
      </Link>
    </div>
  );
};

export default MainMenu;
